<template lang="pug">
modal#subscription-information-modal(
  :close-button-label='$t("button.ok")'
  :title='$t("modal.subscriptionInformation.title")'
  ref='modal'
  v-if='this.signInfo'
)
  .text {{ $t('modal.subscriptionInformation.file') }}
  ul
    li
      small.text {{ $t('modal.subscriptionInformation.fileName') }}: {{ this.signInfo.name }}
    li
      small.text {{ $t('modal.subscriptionInformation.createdAt') }}: {{ this.signInfo.created_at | dateTime }}
  .text.mt-4 {{ $t('modal.subscriptionInformation.envelope') }}
  ul
    li
      small.text {{ $t('modal.subscriptionInformation.subject') }}: {{ this.signInfo.envelope.subject }}
    li
      small.text {{ $t('modal.subscriptionInformation.status') }}: {{ $t(this.signInfo.envelope.state) }}
    li
      small.text {{ $t('modal.subscriptionInformation.createdAt') }}: {{ this.signInfo.envelope.created_at | dateTime }}
  .text.mt-4 {{ $t('modal.subscriptionInformation.signers') }}
  .card.car--recipients.mt-3
    .card-body.card-body--recipients.recipients-detail
      ul.nav.flex-column
        div(
          :key='recipient.id'
          v-for='recipient in this.signInfo.envelope.recipients'
        )
          li
            small.text {{ recipient.addressees[0].value }}
          li
            IconStatus(:iconStatus='recipient.state')
            span.text(style='padding-left: 0.4rem') {{ $t(recipient.state) }}
        <hr>
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import IconStatus from '@/ui/atoms/IconStatus.vue';

export default {
  name: 'SubscriptionInformationModal',
  props: {
    signInfo: [Object, String],
  },
  components: {
    Modal,
    IconStatus,
  },
};
</script>

<style lang="stylus">
.car--recipients
  -webkit-box-shadow: none
  -moz-box-shadow: none
  box-shadow: none
.card-body--recipients
  border: 0.1rem solid #CCCCCC
  border-radius: 0.2rem
  .text
    vertical-align: baseline
    font-size: 14px
</style>
